import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../services/base.service';
import { PopupService } from '../../services/popup.service';
import { MapService } from '../../services/map.service';
import { RetailerService } from '../../services/retailer.service';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';
import { PropertyService } from '../../services/property.service';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { FeatureService } from '../../services/feature.service';
import { Observable, Subject } from 'rxjs/Rx';
import { MyStuffService } from '../../services/my-stuff.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { PinService } from '../../services/pin.service';
import { LoaderService } from '../../services/loader.service';
import { RemovedItemsService } from '../../services/removed-items.service';
import { BrandingService } from '../../services/branding.service';
import { SegmentService } from '../../services/segment.service';
import { SegmentEvents } from '../../constants/SegmentEvents';
import { PrintService } from '../../services/print.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  API_URL = environment.APP.API_URL;
  isUserLoggedIn: boolean;
  initialLoad: boolean = true;
  userMapAccessId: string;
  routeListener: Subscription;

  isOrganizationsFetching: boolean = false;
  organizations: any;

  userLoggedInSubscription: Subscription;
  mapLoadedSubscription: Subscription;
  mapLoadedSubscription2: Subscription;
  fetchPropertiesSubscription: Subscription;
  fetchPinsSubscription: Subscription;
  fetchRetailersSubscription : Subscription;
  fetchAllRemovedSubscription : Subscription;
  fetchRemovedPinsSubscription : Subscription;
  fetchRemovedPropertiesSubscription : Subscription;
  fetchRemovedRetailersSubscription : Subscription;
  fetchAllMapsSubscription: Subscription;
  fetchReceivedMapsSubscription: Subscription;
  fetchSharedMapsSubscription: Subscription;
  fetchDeletedMapsSubscription: Subscription;
  signupCompleteSubscription: any;
  signupErrorSubscription: any;
  signinCompleteSubscription: any;
  signinErrorSubscription: any;
  updatePopupRouteSubscription: any;
  closeTermSubcription: any;
  saveFeatureExecutionData: any;
  executeSegmentIdentifiersSubscription: any;
  closePrintPreviewSubscription: any;
  demoGraphicReportSubscription: any;
  mapsSidebarOptions = {
    API_URL: environment.APP.API_URL,
    environmentName: environment.name,
    userTokenApiCall: '/user-token'
  }

  mapsAddStuffOptions = {
    API_URL: environment.APP.API_URL,
    environmentName: environment.name
  }

  enableRandomRetailers: boolean = false;

  adminIntegratedMapsFilterChanged: Subject<string> = new Subject<string>();

  constructor(public popupService: PopupService, public router: Router,
    public route: ActivatedRoute, public ref: ChangeDetectorRef,
    public baseService: BaseService, public mapService: MapService,
    public userService: UserService, public notificationService: NotificationService,
    public propertyService: PropertyService, public retailerService: RetailerService, public segmentService: SegmentService, public featureService: FeatureService,
    public myStuffService: MyStuffService, public pinService: PinService, public loaderService: LoaderService,
    public removedItemsService: RemovedItemsService, public brandingService: BrandingService, public printService: PrintService) {

      this.adminIntegratedMapsFilterChanged
      .subscribe((inhibitLayer)=>{
        let w = (<any>window),
        inhibitArray = w.mmap.inhibitLayer.property.split(',');
        if(inhibitArray.indexOf(inhibitLayer) !== -1) {
          inhibitArray.splice(inhibitArray.indexOf(inhibitLayer), 1);
        } else {
          inhibitArray.push(inhibitLayer);
        }
        w.mmap.setInhibitLayer('property', inhibitArray.join(','));
        w.Events.publish('detectChanges');
        w.saveMap.resetMapWithCurrentSettings();
      });
  }

  ngOnInit() {
    this.initSubscriptions();
    this.mapService.initializeMapLoadSubscription();
    this.checkedLoggedIn();
    this.brandingService.addJllSiteBrandingClass();
  }

  ngAfterViewInit() {
    let capsuleLogoElement = document.getElementById('propertycapsule-small-logo');
    let w = (<any>window);
    if(capsuleLogoElement) {
      capsuleLogoElement.addEventListener('click', ()=>{
        (<any>window).saveMap.resetMapToDefault();
      });
    }
    this.checkForQueryParams();

    this.signupCompleteSubscription = w.Events.subscribe('SignupComplete', (response)=> {
      this.userService.onSignUp = true;
      this.userService.onLogin(response);
      this.userService.isMobileUserOptionsOpened = false;
      w.Events.publish('detectChanges');
    });

    this.signupErrorSubscription = w.Events.subscribe('SignupError', (e)=> {
      w.Events.publish('detectChanges');
      throw e;
    });

    this.signinCompleteSubscription = w.Events.subscribe('SigninComplete', (response)=> {
      this.userService.onSignIn = true;
      this.userService.onLogin(response);
      this.userService.isMobileUserOptionsOpened = false;
      this.executeVerifyMailAfterSignIn();
      w.Events.publish('detectChanges');
    });

    this.signinErrorSubscription = w.Events.subscribe('SigninError', (e)=> {
      w.Events.publish('detectChanges');
      throw e;
    });

    this.updatePopupRouteSubscription = w.Events.subscribe('updatePopupRoute', (data)=> {
      if (data) {
        data.innerPopup ? this.popupService.updateRoute(data.popup, data.innerPopup) : this.popupService.updateRoute(data);
      } else {
        this.popupService.updateRoute();
      }
    });

    this.closeTermSubcription = w.Events.subscribe('closeTermsPopup', () => {
      this.popupService.popupList.popups['sign-up'] ?
        this.popupService.updateRoute('sign-up') :
        this.popupService.popupList.popups['log-in'] ? this.popupService.updateRoute('log-in') : this.popupService.updateRoute();
    });

    this.executeSegmentIdentifiersSubscription = w.Events.subscribe('executeSegmentIdentifiers', (callback)=> {
      this.userService.onSignUp && this.segmentService.alias();
      this.segmentService.identify();
      this.segmentService.group();
      this.segmentService.timeout(500);
      setTimeout(()=> {
        callback();
      }, 0);
    });

    this.demoGraphicReportSubscription = w.Events.subscribe('openDemographicsReport', (data)=> {
      if(data && this.userService.loggedIn && this.userService.loggedInUser.canGetDemographics
         && this.userService.loggedInUser.canPullReports) {
        this.mapService.showDemographicReport = true;
        this.mapService.selectedDemoPointData = data;
        w.Events.publish('detectChanges');
      }
    });
  }

  initSubscriptions() {
    let w = (<any>window);

    w.Events.subscribe('',(data)=>{
      this.userService.onLogout();
      !data.doNotShowLogin && this.popupService.updateRoute('log-in');
    });

    w.Events.subscribe('segment', (logData) => {
      if(logData.name) {
        this.segmentService.log(logData.name, logData.data);
      } else {
        this.segmentService.log(logData);
      }
    });

    w.Events.subscribe('popup',(data)=>{
      data = (typeof data === 'string')? data: undefined;
      this.popupService.updateRoute(data);
    });

    w.Events.subscribe('closeAddStuffDropdown',()=>{
      this.popupService.updateRoute();
    });

    w.Events.subscribe('openContactSupportPopup', () => {
      if (this.userService.getLoggedIn()) {
        this.popupService.updateRoute('contact-support');
      } else {
        environment.APP.JLL.HOSTNAME ? this.popupService.updateRoute('log-in') : this.popupService.updateRoute('sign-up');
      }
    });

    this.saveFeatureExecutionData = w.Events.subscribe('saveFeatureExecutionData', (callback) => {
      this.featureService.requestObject &&
      this.featureService.requestObject.polygon &&
      (this.featureService.requestObject.polygon = (<any>window).getPolygonGeoJson(this.featureService.requestObject.polygon));
      this.userService.featureExecutionObject = {
        featureToExecute: this.featureService.featureToExecute,
        requestObject: this.featureService.requestObject
      };
      w.Events.publish('detectChanges');
      callback();
    });

    w.Events.subscribe('updateFeatureExecutionAfterSignUp',(data)=>{
      this.featureService.updateExecutionFeature(data.featureToExecute, data.requestObject);
    });

    w.Events.subscribe('initializeBrandingMode',(data)=>{
      this.brandingService.initializeBrandingMode(data);
    });

    w.Events.subscribe('resetToUserBrand',()=>{
      if(this.userService.getLoggedIn()) {
        this.brandingService.initializeBrandingMode(this.userService.loggedInUser.brandingInfo);
      } else {
        this.brandingService.checkAndApplyJllStyles();
      }
    });

    w.Events.subscribe('resetMyStuffData',()=>{
      for(let obj in this.mapService.userMaps) {
        if(this.mapService.userMaps.hasOwnProperty(obj)) {
          this.mapService.userMaps[obj] = [];
        }
      }
      this.myStuffService.allRemovedItems = [];
      this.myStuffService.deletedProperties = [];
      this.myStuffService.deletedRetailers = [];
      this.propertyService.myProperties = [];
      this.retailerService.myRetailers = [];
    });

    w.Events.subscribe('loadLinkMap',(response)=>{
      this.userService.onSingleMapClick(response, null, true);
    });

    //Resets the current saved map which is being viewed.
    w.Events.subscribe('resetSavedMap',()=>{
      if(this.mapService.currentUserMap) {
        this.userMapAccessId = this.mapService.currentUserMap.accessId;
        w.saveMap.previousUnsaved = JSON.parse(JSON.stringify(w.saveMap.defaultMapSettings));
        this.mapService.closeUserCurrentMap();
      }
    });

    w.Events.subscribe('closeUserMap',()=>{
      this.mapService.closeUserCurrentMap();
    });

    w.Events.subscribe('resetDataCompleted',()=>{
      let mapAccessIdQueryParam = w.getQueryStringValue('m').length > 0? w.getQueryStringValue('m'): null;
      if(mapAccessIdQueryParam || this.userMapAccessId) {
        w.saveMap.getSingleMapApiCall(mapAccessIdQueryParam || this.userMapAccessId);
        delete this.userMapAccessId;
      } else if(!w.checkIfAnyQueryParamsExist()) {
        w.localStorageHandler.blockLSUpdate = false;
        this.checkLSAfterDataReset();
      } else {
        this.updateLSAndLoadTiles();
      }
    });

    w.Events.subscribe('changesInCurrentUserMap', () => {
      this.mapService.currentUserMap ? this.mapService.currentUserMap.canRestore = true : '';
      w.Events.publish('detectChanges');
    });

    w.Events.subscribe('getUserData',(res)=>{
      if(res) {
        this.userService.getLoggedInUser().subscribe((userData)=>{
          w.Events.publish('updatedUserData', userData);
        });
      }
    });

    w.Events.subscribe('usageLimitErrorFeature',(res)=>{
      if(res) {
        this.featureService.updateFeature(res);
      }
    });

    w.Events.subscribe('startLoadingWhite', ()=>{
      this.loaderService.addWhiteLoaderClass();
    });

    w.Events.subscribe('endLoadingWhite', ()=>{
      this.loaderService.removeWhiteLoaderClass();
    });

    w.Events.subscribe('startLoadingGrey', ()=>{
      this.loaderService.addGreyLoaderClass();
    });

    w.Events.subscribe('endLoadingGrey', ()=>{
      this.loaderService.removeGreyLoaderClass();
    });

    w.Events.subscribe('notificationError', (data)=>{
      this.notificationService.error(data);
    });

    w.Events.subscribe('notificationInfo', (data)=>{
      this.notificationService.info(data);
    });

    w.Events.subscribe('getLoggedInCheck',(callback)=>{
      callback(this.userService.getLoggedIn());
    });

    this.closePrintPreviewSubscription = this.printService.closePrintPreviewStream.subscribe((value)=>{
      if(value) {
        this.togglePrintPreviewComponent();
      }
    });

    w.Events.subscribe('saveCurrentUserMap', (obj)=>{
       w.saveMap.updateMapData();
       w.saveMap.setMapDataRotateValue();
       obj.data.mapData = w.saveMap.convertMapDataToKeyValue();
       this.mapService.saveMap(obj.data).subscribe((response: any)=>{
        obj.successCallback && obj.successCallback(response);
        this.segmentService.log(SegmentEvents.mapSaved, {
          map_id: response.id
        });
        this.notificationService.info('Your map is Saved');
        w.Events.publish('detectChanges');
      },(error)=>{
        obj.errorCallback && obj.errorCallback(error);
        throw(error);
      });
    });

    w.Events.subscribe('addTrafficSegmentMarker', (marker) => {
      this.featureService.updateExecutionFeature('add-traffic-segment-marker', marker);
    })

   this.loadMyStuffData();
  }

  checkedLoggedIn() {
    let w = (<any>window);
    this.userLoggedInSubscription = this.userService.isLoggedInChangeStream.subscribe((loggedIn)=>{
      if(loggedIn !== null && this.isUserLoggedIn !== loggedIn) {
        this.isUserLoggedIn = loggedIn;
        this.brandingService.removeBrandingStyles();
        this.userService.getLoggedInUser().subscribe((res: any) => {
          if(res && !res.emailAddress) {
            this.brandingService.checkAndApplyJllStyles();
            if(w.mmap && w.mmap.isIntegratedMapsActive()) {
              w.mmap.setInhibitLayer('property', 'public,profile');
              w.setMapDataProperty('propertyFilterSelectedRadio', 'org');
            } else {
              w.mmap.setInhibitLayer('property', 'profile');
              w.setMapDataProperty('propertyFilterSelectedRadio', 'all');
            }
            this.startMapOperations(res);
            this.isUserLoggedIn = false;
            this.userService.loggedIn = false;
            w.Events.publish('updateUserData', null);
            throw {
              status: 401,
              _body: {
                apiErrorCode: 'NOT_LOGGED_IN'
              },
              doNotShowLogin: true
            };
          }

          if(!this.isUserLoggedIn) {
            this.isUserLoggedIn = true;
            this.userService.onLogin(res);
          }

          //Apply branding
          this.brandingService.initializeBrandingMode(res ? res.brandingInfo : null);
          this.userService.loggedInUser = res;
          w.Events.publish('updateUserData', this.userService.loggedInUser);
          this.segmentService.excludeInternalTraffic(res);
          (<any>window).Events.publish('getLoggedInUser', res);

          if(this.userService.onSignIn || this.userService.onSignUp) {
            (<any>window).Events.publish('executeSegmentIdentifiers', ()=>{
              this.userService.onSignIn && this.segmentService.log(SegmentEvents.loggedIn, {linkedin: false, product: 'maps'});
              this.userService.onSignUp && this.segmentService.log(SegmentEvents.signupSuccess, {linkedin: false, product: 'maps'});
            });
            this.featureService.featureToExecute && this.featureService.requestObject &&
            this.featureService.executeFeature();
            this.featureService.updateFeature();
            this.featureService.resetExecutionFeature();
          };
          w.mmap.setAllInhibitLayer('');
          if(res && res.emailAddress && res.organizationType === 'CAPSULE') {
            w.mmap.setInhibitLayer('property', 'public,profile');
            w.setMapDataProperty('propertyFilterSelectedRadio', 'org');
          }
          this.executeFeatureFromLinkedIn();
          this.executeSignUpLoginSuccess();
          this.assignUserInitials();
          setTimeout(()=>{
            this.startMapOperations(res);
          }, 0);
        });
      }
    });
  }

  executeFeatureFromLinkedIn() {
    if (this.route.snapshot.queryParams['featureToExecute'] || this.route.snapshot.queryParams['fromLinkedIn']) {
      let featureExecutionData = JSON.parse(this.route.snapshot.queryParams['featureToExecute']);
      this.featureService.updateExecutionFeature(featureExecutionData.featureToExecute, featureExecutionData.requestObject);
      this.userService.linkedInFeatureSource.next(true);
      setTimeout(()=>{
        this.router.navigate([(<any>window).location.pathname], {
          queryParams: {
            fromLinkedIn: null,
            featureToExecute: null
          },
        });
      }, 0);
    }
  }

  executeVerifyMailAfterSignIn() {
    if(this.route.snapshot.queryParams['v'] && this.route.snapshot.queryParams['redirectKey'] === 'maps') {
      this.popupService.updateRoute('verify-email');
    }
  }

  executeSignUpLoginSuccess() {
    let redirectionSource = this.route.snapshot.queryParams['redirectedFrom'],
        w = (<any>window);
    if(redirectionSource) {
      if(redirectionSource === 'signup') {
        this.userService.onSignUp = true;
        w.Events.publish('executeSegmentIdentifiers', ()=>{
          this.segmentService.log(SegmentEvents.signupSuccess, {linkedin: false, product: 'maps'});
        });
      } else if(redirectionSource === 'login') {
        this.userService.onSignIn = true;
        w.Events.publish('executeSegmentIdentifiers', ()=>{
          this.segmentService.log(SegmentEvents.loggedIn, {linkedin: false, product: 'maps'});
        });
      }
    }
    this.router.navigate([(<any>window).location.pathname], {
      queryParams: {
        redirectedFrom: null
      },
      queryParamsHandling: 'merge'
    });
  }

  loadMyStuffData() {
    this.mapLoadedSubscription2 = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        (<any>window).Events.publish('googleMapLoaded');
        this.fetchAllMapsSubscription = this.myStuffService.fetchAllMapsStream.subscribe((mapSourceUpdated) => {
          if(mapSourceUpdated && this.isUserLoggedIn) {
            this.myStuffService.fetchAllMaps();
          }
        });

        this.fetchReceivedMapsSubscription = this.myStuffService.fetchReceivedMapsStream.subscribe((mapSourceUpdated) => {
          if(mapSourceUpdated && this.isUserLoggedIn) {
            this.myStuffService.fetchReceivedMaps();
          }
        });

        this.fetchSharedMapsSubscription = this.myStuffService.fetchSharedMapsStream.subscribe((mapSourceUpdated) => {
          if(mapSourceUpdated && this.isUserLoggedIn) {
            this.myStuffService.fetchSharedMaps();
          }
        });

        this.fetchDeletedMapsSubscription = this.myStuffService.fetchDeletedMapsStream.subscribe((mapSourceUpdated) => {
          if(mapSourceUpdated && this.isUserLoggedIn) {
            this.myStuffService.fetchDeletedMaps();
          }
        });

        this.fetchPropertiesSubscription = this.propertyService.fetchPropertiesStream.subscribe((propertySourceUpdated)=>{
          if(propertySourceUpdated && this.isUserLoggedIn) {
            this.propertyService.searchProperties();
          }
        });

        this.fetchPinsSubscription = this.pinService.fetchPinsStream.subscribe((pinsSourceUpdated)=>{
          if(pinsSourceUpdated && this.isUserLoggedIn) {
            this.pinService.searchPins();
          }
        });

        this.fetchRetailersSubscription = this.retailerService.fetchRetailersStream.subscribe((retailerSourceUpdated)=>{
          if(retailerSourceUpdated && this.isUserLoggedIn) {
            this.retailerService.searchRetailers();
          }
        });

        this.fetchAllRemovedSubscription = this.removedItemsService.fetchAllRemovedItemsStream.subscribe((allRemovedItemsSourceUpdated)=>{
          if(allRemovedItemsSourceUpdated && this.isUserLoggedIn) {
            this.removedItemsService.searchAllRemovedItems();
          }
        });

        this.fetchRemovedPinsSubscription = this.removedItemsService.fetchRemovedPinsStream.subscribe((removedPinsSourceUpdated)=>{
          if(removedPinsSourceUpdated && this.isUserLoggedIn) {
            this.removedItemsService.searchPins();
          }
        });

        this.fetchRemovedPropertiesSubscription = this.removedItemsService.fetchRemovedPropertiesStream.subscribe((removedPropertiesSourceUpdated)=>{
          if(removedPropertiesSourceUpdated && this.isUserLoggedIn) {
            this.removedItemsService.searchDeletedProperties();
          }
        });

        this.fetchRemovedRetailersSubscription =  this.removedItemsService.fetchRemovedRetailersStream.subscribe((removedRetailersSourceUpdated)=>{
          if(removedRetailersSourceUpdated && this.isUserLoggedIn) {
            this.removedItemsService.searchDeletedRetailers();
          }
        });
      }
    });
  }

  startMapOperations(res) {
    let w = (<any>window);
    this.mapService.mapLoadedChangeSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        this.resetMapData();
        this.mapLoadedSubscription && this.mapLoadedSubscription.unsubscribe();
        w.Events.publish('userTokenCompleted', res);
      }
    });
  }

  resetMapData() {
    let w = (<any>window);
    w.Events.publish('updateUserData', this.userService.loggedInUser);
    !this.userService.onSignUp && w.Events.publish('resetData', this.userService.loggedInUser);
    if(this.mapService.currentUserMap && this.userService.onSignUp) {
      w.Events.publish('resetSavedMap');
      w.Events.publish('resetDataCompleted');
    }
  }

  loadDataFromLS() {
    (<any>window).localStorageHandler.retrievePreviousState();
  }

  checkLSAfterDataReset() {
    let w =(<any>window);
    if(w.lsAvailable) {
      if(w.localStorage.getItem('propertyCapsule-'+ environment.name +'-mapData')) {
        this.loadDataFromLS();
      } else {
        this.updateLSAndLoadTiles();
      }
    }
  }

  updateLSAndLoadTiles() {
    let w = (<any>window);
    w.localStorageHandler.fullyUpdateMapDataInLS();
    w.mapItem.onTilesLoaded();
  }

  checkForQueryParams() {
    let w = (<any>window);
    this.router.events.subscribe((event)=>{
      if(event instanceof NavigationEnd && this.initialLoad) {
        this.initialLoad = false;
        let queryParams = this.route.snapshot.queryParams;
        this.mapService.mapLoadedChangeSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
          if(value) {
            if(!isNaN(parseFloat(queryParams['lat'])) && !isNaN(parseFloat(queryParams['lng']))) {
              let latLng = new w.google.maps.LatLng(parseFloat(queryParams['lat']),parseFloat(queryParams['lng']));
              if(queryParams['pin']) {
                w.autoComplete.marker = new w.RichMarker({
                  position: latLng,
                  map: w.map,
                  clickable: false,
                  shadow: '',
                  content: '<div><img src="'+w.SEARCH_MARKER+'" style="height:38px;width:28px"></div>'
                });
              }
            }
            if(queryParams['lite']) {
              if(queryParams['allretailers']) {
                w.apiRetailer.showAllRetailers = true;
              }
            } else {
              this.checkForFirstTimeUser();
            }
          }
        });
      }
      event instanceof NavigationEnd && this.isUserLoggedIn && this.userService.setLoggedInCookie();
    });
  }

  checkForFirstTimeUser() {
    if(this.router.isActive('/map', false)) {
      this.checkToAddRandomRetailers();
    } else {
      this.routeListener = this.router.events.subscribe((event:any) => {
        if (event instanceof NavigationEnd) {
          if(this.router.isActive('/map', false)) {
            this.routeListener.unsubscribe();
            this.checkToAddRandomRetailers();
          }
        }
      });
    }
  }

  checkToAddRandomRetailers() {
    let w = (<any>window);
    if(!w.onMobileDevice()) {
      let hasVisitedBefore = Cookie.get('marqetmap-' + environment.name + '.hasVistedBefore');
      if(!hasVisitedBefore) {
        Cookie.set('marqetmap-' + environment.name + '.hasVistedBefore', 'true', 2147483647, '/');
        if(!this.route.snapshot.queryParams['m']) {
          this.enableRandomRetailers = true;
          w.Events.publish('detectChanges');
        }
      }
    }
  }

  assignUserInitials() {
    this.userService.getUser(this.userService.loggedInUser).subscribe((result: any) => {
      this.userService.user = result;
      this.userService.userInitials = result.fullName.split(' ')[0].charAt(0) + result.fullName.split(' ')[1].charAt(0);
    });
  }

  toggleSignIn() {
    (!this.popupService.popupList.popups['log-in'])?
    this.popupService.updateRoute('log-in'):
    this.popupService.updateRoute();
  }

  toggleSignUp() {
    (!this.popupService.popupList.popups['sign-up'])?
    this.popupService.updateRoute('sign-up'):
    this.popupService.updateRoute();
  }

  toggleProfile() {
    (!this.popupService.popupList.popups['profile'])?
    this.popupService.updateRoute('profile'):
    this.popupService.updateRoute();
  }

  toggleMyStuff() {
    if (!this.popupService.popupList.popups['my-stuff']) {
      this.toggleMyStuffPopupOpenCheck(false);
      this.fetchCurrentOpenMyStuffSection();
      this.popupService.updateRoute('my-stuff');
      this.segmentService.log(SegmentEvents.mapMyStuffClicked);
    } else {
      this.popupService.updateRoute();
    }
  }

  toggleMyStuffPopupOpenCheck(toggle) {
    for (let obj in this.myStuffService.myStuffSectionOpened) {
      if(this.myStuffService.myStuffSectionOpened.hasOwnProperty(obj)) {
        this.myStuffService.myStuffSectionOpened[obj] = toggle;
      }
    }
  }

  fetchCurrentOpenMyStuffSection() {
    let activeMyStuffSection = this.popupService.getActiveMyStuffPopup();

    if(activeMyStuffSection.subInner) {
      switch (activeMyStuffSection.inner + '-' + activeMyStuffSection.subInner) {
        case 'maps-all':
          this.myStuffService.fetchAllMapsSource.next(true);
          break;

        case 'maps-received':
          this.myStuffService.fetchReceivedMapsSource.next(true);

          break;

        case 'maps-shared':
          this.myStuffService.fetchSharedMapsSource.next(true);
          break;

        case 'removed-all':
          this.removedItemsService.fetchAllRemovedItemsSource.next(true);
          break;

        case 'removed-properties':
          this.removedItemsService.fetchRemovedPropertiesSource.next(true);
          break;

        case 'removed-retailers':
          this.removedItemsService.fetchRemovedRetailersSource.next(true);
          break;

        case 'removed-pins':
          this.removedItemsService.fetchRemovedPinsSource.next(true);
          break;

        case 'removed-maps':
          this.myStuffService.fetchDeletedMapsSource.next(true);
          break;

        default:
          this.myStuffService.fetchAllMapsSource.next(true);
      }
    } else {
      switch (activeMyStuffSection.inner) {
        case 'properties':
          this.propertyService.fetchPropertiesSource.next(true);
          break;

        case 'retailers':
          this.retailerService.fetchRetailersSource.next(true);
          break;

        case 'pins':
          this.pinService.fetchPinsSource.next(true);
          break;

        default:
          this.myStuffService.fetchAllMapsSource.next(true);
      }
    }
  }

  toggleAddStuff() {
    if(this.userService.loggedIn) {
      if(!this.popupService.popupList.popups['add-stuff']) {
        (!this.mapService.isMapReceived)?
        this.popupService.updateRoute('add-stuff'):
        this.notificationService.info('You cannot edit received map.');
      } else {
        this.popupService.updateRoute();
      }
    } else {
      this.popupService.updateRoute('sign-up');
    }
  }

  toggleSaveMap() {
      if(!this.userService.loggedIn) {
        this.popupService.updateRoute('sign-up');
      } else {
      if(!this.popupService.popupList.popups['save-map']) {
        this.popupService.updateRoute('save-map');
        this.mapService.saveMapChangeSource.next(true);
      } else {
        this.popupService.updateRoute();
      }
    }
  }

  toggleShareMap() {
    if(!this.userService.loggedIn) {
      this.popupService.updateRoute('sign-up');
    } else {
    if(!this.popupService.popupList.popups['share-map']) {
        this.popupService.updateRoute('share-map');
        this.mapService.shareMapChangeSource.next(true);
      } else {
        this.popupService.updateRoute();
      }
    }
  }

  togglePrintPreviewComponent() {
    if(!this.userService.loggedIn) {
      this.popupService.updateRoute('sign-up');
    } else {
      if(!this.popupService.popupList.popups['print']) {
        this.popupService.updateRoute('print');
      } else {
        this.popupService.updateRoute();
      }
      (<any>window).Events.publish('detectChanges');
    }
  }

  toggleOrganizationDropdown() {
    let w = (<any>window);
    if(!this.organizations && !this.isOrganizationsFetching) {
      this.isOrganizationsFetching = true;
      this.userService.getOrganizations().subscribe((response)=>{
        this.organizations = response;
        this.isOrganizationsFetching = false;
        w.Events.publish('detectChanges');
      }, (error)=>{
        this.isOrganizationsFetching = false;
        w.Events.publish('detectChanges');
      });
    }
    w.Events.publish('detectChanges');
  }

  selectOrganizationFromDropdown(event, organization) {
    let w = (<any>window);
    this.router.navigate(['/map'], {
      queryParams: {
        mastermap : true,
        customerId: organization.organizationGlobalId
      }
    });
    organization.organizationColor && w.alterLayersSidebarColorTheme(organization.organizationColor, organization.organizationColor);
    w.mmap.updateMasterMapMode(true, organization.organizationGlobalId);
    this.userService.organizationName = organization.name;
    w.Events.publish('detectChanges');
    w.saveMap.resetMapWithCurrentSettings();
  }

  organizationPropertiesShown() {
    return !(<any>window).mmap.checkIfInhibitLayerActive('property', 'organization');
  }

  publicPropertiesShown() {
    return !(<any>window).mmap.checkIfInhibitLayerActive('property', 'public');
  }

  getCurrentZoomLevel() {
    let w = (<any>window);
    return w.mapData && w.mapData.currentZoomLevel? w.mapData.currentZoomLevel: '';
  }

  ngOnDestroy() {
    this.userLoggedInSubscription && this.userLoggedInSubscription.unsubscribe();
    this.mapLoadedSubscription && this.mapLoadedSubscription.unsubscribe();
    this.mapLoadedSubscription2 && this.mapLoadedSubscription2.unsubscribe();
    this.fetchAllMapsSubscription && this.fetchAllMapsSubscription.unsubscribe();
    this.fetchReceivedMapsSubscription && this.fetchReceivedMapsSubscription.unsubscribe();
    this.fetchSharedMapsSubscription && this.fetchSharedMapsSubscription.unsubscribe();
    this.fetchDeletedMapsSubscription && this.fetchDeletedMapsSubscription.unsubscribe();
    this.fetchPropertiesSubscription && this.fetchPropertiesSubscription.unsubscribe();
    this.fetchPinsSubscription && this.fetchPinsSubscription.unsubscribe();
    this.fetchRetailersSubscription && this.fetchRetailersSubscription.unsubscribe();
    this.fetchAllRemovedSubscription && this.fetchAllRemovedSubscription.unsubscribe();
    this.fetchRemovedPinsSubscription && this.fetchRemovedPinsSubscription.unsubscribe();
    this.fetchRemovedPropertiesSubscription && this.fetchRemovedPropertiesSubscription.unsubscribe();
    this.fetchRemovedRetailersSubscription && this.fetchRemovedRetailersSubscription.unsubscribe();
    this.signupCompleteSubscription && this.signupCompleteSubscription.unsubscribe();
    this.signupErrorSubscription && this.signupErrorSubscription.unsubscribe();
    this.signinCompleteSubscription && this.signinCompleteSubscription.unsubscribe();
    this.signinErrorSubscription && this.signinErrorSubscription.unsubscribe();
    this.saveFeatureExecutionData && this.saveFeatureExecutionData.unsubscribe();
    this.executeSegmentIdentifiersSubscription && this.executeSegmentIdentifiersSubscription.unsubscribe();
    this.closePrintPreviewSubscription && this.closePrintPreviewSubscription.unsubscribe();
    this.demoGraphicReportSubscription && this.demoGraphicReportSubscription.unsubscribe();
    this.closeTermSubcription && this.closeTermSubcription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts